export const JOB_PHASE_NOTES_MIN_LENGTH = 1;
export const JOB_PHASE_NOTES_MAX_LENGTH = 500;

/**
 * Total Cost (Prod Payables MS): zero or greater, up to two decimal places.
 * The ceiling mirrors the job_phase."costTotal" column, numeric(7,2).
 */
export const JOB_PHASE_COST_TOTAL_MIN = 0;
export const JOB_PHASE_COST_TOTAL_MAX = 99999.99;
export const JOB_PHASE_COST_TOTAL_DECIMAL_PLACES = 2;
